import { VoiceIds } from "@/_lib/constants";

export const getVoiceId = (gender: string = ''): VoiceIds => {
  const normalizedGender = gender.toUpperCase().replace('-', '_') as keyof typeof VoiceIds;
  return VoiceIds[normalizedGender] ?? VoiceIds.NONBINARY;
};